export default {
  app: {
    notFound: {
      title: '找不到网页。',
      subtitle: '看来您迷路了。',
      text: '不用担心，我们将帮助您从这里导航',
    },
  },
};
